import { render, staticRenderFns } from "./ppt_index.vue?vue&type=template&id=82f877cc&scoped=true"
import script from "./ppt_index.vue?vue&type=script&lang=js"
export * from "./ppt_index.vue?vue&type=script&lang=js"
import style0 from "./ppt_index.vue?vue&type=style&index=0&id=82f877cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f877cc",
  null
  
)

export default component.exports